import React from "react";

export class CookiePolicyIT extends React.Component {
    render() {
        return (
            <>
                <p>
                    Ultimo aggiornamento: <b>28/11/2024</b>
                    <br />
                    <br />
                </p>
                <p>
                    Il presente documento è stato redatto ai sensi del Regolamento UE 2016/679 (il "GDPR") per consentire agli utenti di comprendere quali cookie sono installati
                    quando utilizzano il sito web https://www.dobcomed.com (il "Sito").
                </p>
                <h2>1. Titolare del trattamento e responsabile della protezione dei dati</h2>
                <p>
                    DH Healthcare GmbH, con sede legale in Konrad-Zuse-Platz 1-3, 53227 Bonn, Germany, è il titolare del trattamento dei dati personali (i Dati) degli utenti del
                    Sito Web raccolti utilizzando i cookie. Per qualsiasi richiesta è possibile scrivere a DH Healthcare GmbH all'indirizzo fisico sopra indicato o tramite
                    l'indirizzo e-mail.
                    <br />
                    <br />
                    DH Healthcare GmbH ha nominato un Responsabile della protezione dei dati ("DPO"), che può essere contattato all'indirizzo Dpo.belgium@dedalus.eu
                </p>
                <h2>2. Dati trattati da DH Healthcare GmbH</h2>
                <p>
                    L'applicazione sul sito prevede l'utilizzo di cookie, brevi stringhe di testo che i siti visitati inviano al browser dell'utente , dove vengono memorizzati per
                    essere poi trasmessi agli stessi siti web in occasione di visite successive. Nel corso della navigazione su un sito, l'utente potrebbe ricevere sul suocomputer
                    anche cookie di siti o di web server diversi da quello che lo sta visitando (c.d. cookie di "terze parti"). È possibile distinguere:
                    <br />
                    <br />
                    A. Cookie tecnici, che consentono di svolgere attività legate al funzionamento del Sito.
                    <br />
                    <br />
                    B. Cookie di profilazione, utilizzati per analizzare il comportamento degli utenti e, se necessario, per inviare messaggi pubblicitari in linea con le
                    preferenze manifestate dallo stesso nell'ambito della navigazione.
                    <br />
                    <br />
                    C. Archiviazione locale, che consente di svolgere attività connesse al funzionamento del Sito.
                </p>
                <p>
                    <br />
                    Questo Sito Web utilizza i seguenti cookie:
                </p>
                <h3>a) Cookie tecnici</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Ospite</th>
                            <th>Categoria</th>
                            <th>Descrizione</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>.ASPXAUTH</td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>Autenticazione del portale DeepUnity PACSonWEB</td>
                        </tr>
                        <tr>
                            <td>ASP.NET_SessionId</td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>ID della sessione del portale DeepUnity PACSonWEB</td>
                        </tr>
                        <tr>
                            <td>Dobco.AcceptedNecessaryCookies</td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>Questo cookie viene impostato se si sceglie di consentire tutti i cookie e si registra quando è stato impostato.</td>
                        </tr>
                        <tr>
                            <td>.AspNetCore.Culture </td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>Registra la scelta della lingua non appena viene modificata manualmente.</td>
                        </tr>
                        <tr>
                            <td>POWLanguage</td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>Registra la scelta della lingua non appena viene modificata manualmente (la lingua del browser viene utilizzata come standard).</td>
                        </tr>
                        <tr>
                            <td>RETURNSCU</td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>Portale clienti in cui si è effettuato l'accesso.</td>
                        </tr>
                        <tr>
                            <td>Dobco.LocalImageCaches</td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>Registra le cache di immagini locali, collegate all'utente.</td>
                        </tr>
                        <tr>
                            <td>Dobco.ExternalLogin</td>
                            <td>Dobco</td>
                            <td>Necessario</td>
                            <td>Viene utilizzato per salvare lo stato durante un roundtrip di login esterno. È necessario per motivi di sicurezza per prevenire attacchi CSRF e replay. Il cookie sarà criptato.</td>
                        </tr>
                        <tr>
                            <td>Dobco.AcceptedAllCookies </td>
                            <td>Dobco</td>
                            <td>Funzionale</td>
                            <td>Questo cookie viene impostato se si sceglie di consentire tutti i cookie e si registra quando è stato impostato.</td>
                        </tr>
                    </tbody>
                </table>
                <h3>b) Cookie analytics/di profilazione</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Ospite</th>
                            <th>Durata</th>
                            <th>Categoria</th>
                            <th>Descrizione</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>_GA</td>
                            <td>Google</td>
                            <td>2 anni</td>
                            <td>Analitico</td>
                            <td>Utilizzato per distinguere gli utenti.</td>
                        </tr>
                        <tr>
                            <td>_GID</td>
                            <td>Google</td>
                            <td>24 ore</td>
                            <td>Analitico</td>
                            <td>Utilizzato per distinguere gli utenti.</td>
                        </tr>
                        <tr>
                            <td>_GA_&lt;container_id&gt;</td>
                            <td>Google</td>
                            <td>2 anni</td>
                            <td>Analitico</td>
                            <td>Utilizzato per rendere persistente lo stato della sessione.</td>
                        </tr>
                    </tbody>
                </table>
                <h3>c) Archiviazione locale (Host: Dobco; Categoria: Necessario)</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Descrizione</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>cookie-shownNews</td>
                            <td>L'ultima volta che avete aperto gli avvisi.</td>
                        </tr>
                        <tr>
                            <td>POWHomerBGuid</td>
                            <td>ID per l'utilizzo di HomeReading.</td>
                        </tr>
                        <tr>
                            <td>cookie-POW3StudyTutorial</td>
                            <td>Registra se l'esercitazione è già stata mostrata.</td>
                        </tr>
                        <tr>
                            <td>POW3SharingOtherDestinationSettings</td>
                            <td>Impostazioni preferite per la condivisione di uno studio.</td>
                        </tr>
                        <tr>
                            <td>printing_check_openByDefault</td>
                            <td>Impostazione preferita per la stampa di un'indagine.</td>
                        </tr>
                        <tr>
                            <td>cookie-POW3LoginSource</td>
                            <td>Portale clienti in cui si è effettuato l'accesso.</td>
                        </tr>
                        <tr>
                            <td>cookie-acceptedPOW3Cookies</td>
                            <td>Registra se l'informativa sui cookie è già stata mostrata.</td>
                        </tr>
                        <tr>
                            <td>ShownImportNews</td>
                            <td> Registrazione dei fatti di cronaca importanti già mostrati.</td>
                        </tr>
                        <tr>
                            <td>Reportfontsize</td>
                            <td> Dimensione del carattere del report nel visualizzatore.</td>
                        </tr>
                        <tr>
                            <td>cookie-POW3LoginOption</td>
                            <td> Modalità di accesso (paziente/medico).</td>
                        </tr>
                        <tr>
                            <td>cookie-uniqueBrowserIdentifier</td>
                            <td>
                                Identifica in modo univoco il vostro browser all'interno di DeepUnity PACSonWEB. Viene utilizzato per determinare se viene richiesto o meno
                                l'inserimento di un OTP durante l'accesso.
                            </td>
                        </tr>
                        <tr>
                            <td>cookie-last-audio-out-volume</td>
                            <td> Salva l'ultimo livello di uscita del volume audio utilizzato.</td>
                        </tr>
                        <tr>
                            <td>cookie-PreferredRecognitionLanguage</td>
                            <td> Salva la lingua di riconoscimento vocale preferita.</td>
                        </tr>
                        <tr>
                            <td>cookie-scalingFactorConfiguration</td>
                            <td>Salva il fattore di scala preferito e la risoluzione iniziale corrispondente.</td>
                        </tr>
                        <tr>
                            <td>cookie-dontShowPopupForNewsIds</td>
                            <td>Identifica i popup delle notizie che non si desidera più visualizzare.</td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    Sebbene i cookie tecnici necessari non possano essere rifiutati dall'utente del Sito, in quanto strettamente funzionali al Sito stesso, l'utente può scegliere
                    liberamente di accettare o rifiutare l'utilizzo dei cookie analytics, di profilazione e non strettamente necessari. L'utente può impostare e rivedere le proprie
                    scelte in merito ai cookie con la funzione "Modifica delle impostazioni dei cookie" disponibile sul sito web (Sezione "Legale”)
                </p>
                <h2>3. Finalità e base giuridicadel trattamento</h2>
                <p>
                    Con icookie vengono perseguiti i seguenti scopi:
                    <br />
                    <br />
                    3.1. Per consentire la navigazione del sito Webse la sua funzionalità fluida. La base giuridica del trattamento è la fornitura agli utenti di servizi connessi
                    al sito web e il legittimo interesse di Dedalus ad avere un sito web funzionale.
                    <br />
                    <br />
                    3.2 Per adempiere ad eventuali obblighi previsti da leggi, regolamenti o normativa comunitaria, ovvero per ottemperare a richieste delle autorità. La base
                    giuridica del trattamento è l'obbligo di Dedalus di rispettare la normativa inderogabile.
                    <br />
                    <br />
                    3.3 Analizzare il comportamento dell'utente ed eventualmente inviargli messaggi pubblicitari in linea con le preferenze manifestate dallo stesso durante la
                    navigazione. La base giuridica del trattamento in questo caso è il consenso dell'interessato.
                    <br />
                    <br />
                    3.4 Per le esigenze di difesa dei diritti di Dedalus nell'ambito di eventuali contenziosi, anche in sede giudiziale. La base giuridica del trattamento è il
                    legittimo interesse del Titolare a tutelare i propri diritti.
                    <br />
                    <br />
                    Il conferimento dei Dati è facoltativo, ma (salvo i casi di trattamento basato sul consenso) il mancato conferimento dei Dati impedisce al Titolaredi consentire
                    la navigazione del Sito
                </p>
                <h2>4. Destinatari dei Dati</h2>
                <p>
                    I Dati potranno essere comunicati:
                    <br />
                    <br />
                    (a) a soggetti terzi che abbiano necessità di svolgere specifiche attività in relazione ai Dati, in conformità alle finalità del trattamento, ovvero a fornitori
                    di servizi al Titolare.
                    <br />
                    (b) ad autorità, enti e/o soggetti ai quali i Dati devono essere comunicati, in forza di disposizioni cogenti di legge o contrattuali.
                    <br />
                    (c) in altre circostanze, come acquisizioni e vendite a potenziali società terze, quando prevediamo di vendere o trasferire parte o tutta la nostra attività.
                </p>
                <h2>5. Trasferimento dei Dati al di fuoridello Spazio Economico Europeo</h2>
                <p>
                    Per quanto riguarda l'eventuale trasferimento dei Dati verso Paesi non appartenenti allo Spazio Economico Europeo, il trattamento avverrà secondo una delle
                    modalità legalmente consentite e quindi mediante la selezione di destinatari stabiliti in Paesi ritenuti adeguati dalla Commissione Europea o mediante la
                    stipula di clausole contrattuali standard.
                </p>
                <h2>6. Conservazione dei dati</h2>
                <p>
                    I Dati saranno conservati solo per il tempo necessario agli scopi per cui sono stati raccolti, rispettando i principi di limitazione e minimizzazione della
                    conservazione. Più precisamente, i termini di durata dei cookie sono definiti nella precedente sezione 2. Per i Dati il cui trattamento è basato sul consenso
                    dell'interessato, si precisa che gli stessi saranno conservati fino alla revoca di tale consenso.
                </p>
                <h2>7. Diritti degli interessati</h2>
                <p>
                    In presenza dei presupposti legali pertinenti, l'interessato può chiedere al Titolare o al DPO l'accesso ai propri Dati, la rettifica o la cancellazione degli
                    stessi o di opporsi al loro trattamento, di chiedere la limitazione del trattamento nei casi previsti dall'articolo 18 GDPR, nonché di ottenere in modo
                    strutturato, formato comunemente usato, e leggibile da dispositivo automatico, dei dati che lo riguardano, nei casi previsti dall'articolo 20 GDPR.
                    <br />
                    <br />
                    Inoltre, l'utente ha il diritto di revocare in qualsiasi momento il consenso al trattamento, senza pregiudicare la liceità del trattamento effettuato dal
                    Titolare prima della revoca.
                    <br />
                    Le richieste vanno rivolte per iscritto al Titolare del trattamento ai recapiti sopra indicati.
                    <br />
                    <br />
                    In ogni caso, l'interessato può proporre reclamo al Garante per la Protezione dei Dati Personali qualora ritenga che il trattamento dei suoi Dati sia contrario
                    alle normative vigenti.
                </p>
            </>
        );
    }
}
